const initialValues = {
  name: '',
  email: '',
  subject: '',
  message: '',
}

export default initialValues
export type ContactShape = typeof initialValues
